import Vue from 'vue';
import Str from "../helpers/Str";

export default {
    install(Vue) {
        // Generates a random integer value
        Vue.prototype.randomInt = max => {
            max = max || 10;
            return Math.floor(Math.random() * Math.floor(max));
        };

        // Generates a Base 64-encoded version of the current timestamp
        Vue.prototype.randomId = () => {
            return btoa(Date.now() + this.randomInt(9999));
        };

        // Parse an Axios error response into a displayable message
        Vue.prototype.parseError = function(error) {
            let message = "";
            let response = error.response.data;
            if (
                _.has(response, "message") &&
                response.message.trim().length > 0
            ) {
                message = response.message;
            } else if (_.has(response, "exception")) {
                message = "Uncaught Exception: " + response.exception;
                message += "<br />File: " + response.file;
                message += "<br />Line: " + response.line;
            } else {
                message = error.message;
            }
            return message;
        };
    }
};
